export default "__VITE_ASSET__48f8d711__"